import VueDragZone from './vue/drag-zone/index.js'

Vue.use(VueDragZone);

Vue.component('lb-text-input', require('./vue/lb-text-input.vue').default);

Vue.component('editable-table', require('./vue/editable-table.vue').default);
Vue.component('rich-text-area', require('./vue/rich-text-area.vue').default);
Vue.component('status-message', require('./vue/statusMessage.vue').default);
Vue.component('busy-spinner', require('./vue/busySpinner.vue').default);
Vue.component('assign-salesman-modal', require('./vue/assign-salesman-modal.vue').default);
Vue.component('unassign-salesman-modal', require('./vue/unassign-salesman-modal.vue').default);
Vue.component('salesmen-filter', require('./vue/salesmen-filter.vue').default);

Vue.component('sorting-header', require('./vue/sorting-header.vue').default);

Vue.component('table-views', require('./Tables/vue/views/table-views.vue').default);
Vue.component('table-table', require('./Tables/vue/table/table-table.vue').default);

Vue.component('filter-boolean', require('./Tables/vue/filters/filter-boolean').default);
Vue.component('filter-date-between', require('./Tables/vue/filters/filter-date-between').default);
Vue.component('filter-dropdown', require('./Tables/vue/filters/filter-dropdown').default);
Vue.component('filter-number-between', require('./Tables/vue/filters/filter-number-between').default);
Vue.component('filter-select', require('./Tables/vue/filters/filter-select').default);
Vue.component('filter-text', require('./Tables/vue/filters/filter-text').default);

Vue.component('report-detail', require('./Reports/vue/report-detail.vue').default);

Vue.component('push-notifications-registration-page', require('./PushNotifications/vue/push-notifications-registration-page.vue').default);

// resources
Vue.component('resources-dictionary-page', require('./Resources/vue/resources-dictionary-page.vue').default);
Vue.component('resources-dictionary-row', require('./Resources/vue/resources-dictionary-row.vue').default);
Vue.component('resources-dictionary-edit-modal', require('./Resources/vue/resources-dictionary-edit-modal.vue').default);

Vue.component('btn', require('./vue/btn.vue').default);

Vue.component('integrity-check-detail', require('./IntegrityChecks/vue/integrity-check-detail.vue').default);
Vue.component('img-upload', require('./Docs/vue/img-upload').default);

Vue.component('integrity-check-detail', require('./Errors/vue/integrity-check-detail').default);
